var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-footer',[_vm._v("© JLS Digital AG 2023, Libellenrain 17, 6004 Luzern")])
}
var staticRenderFns = []

export { render, staticRenderFns }